// Retargets the source animation clips onto the character skeletons.
import * as THREE from 'three';
import * as SkeletonUtils from 'three/addons/utils/SkeletonUtils.js';
import { FINGERS, animSrc } from './loader.js';

export let wq, retarget;

export function buildRetargeting() {
  retarget = function retarget(c, root) {
    const tgt = SkeletonUtils.clone(root),
      tb = {};
    tgt.traverse((o) => {
      if (o.isBone) tb[o.name] = o;
    });
    for (const n in srcRest) srcB[n].quaternion.copy(srcRest[n]);
    src.updateMatrixWorld(true);
    tgt.updateMatrixWorld(true);
    const names = Object.keys(tb).filter((n) => srcB[n] && !FINGERS.test(n)); // traverse order: parents first
    for (const n of names) {
      const b = tb[n],
        kids = b.children.filter((k) => k.isBone && srcB[k.name]),
        kid = kids.find((k) => CHAIN.test(k.name)) || kids[0];
      if (!kid) continue;
      const q = new THREE.Quaternion().setFromUnitVectors(
          boneDir(b, kid),
          boneDir(srcB[n], srcB[kid.name]),
        ),
        pq = wq(b.parent);
      b.quaternion.premultiply(pq.clone().invert().multiply(q).multiply(pq));
      b.updateMatrixWorld(true);
    }
    const off = {};
    for (const n of names) off[n] = wq(srcB[n]).invert().multiply(wq(tb[n]));
    const mixer = new THREE.AnimationMixer(src),
      act = mixer.clipAction(c).play(),
      fps = 30,
      N = Math.max(2, Math.round(c.duration * fps) + 1);
    const times = new Float32Array(N),
      vals = Object.fromEntries(names.map((n) => [n, new Float32Array(N * 4)]));
    for (let i = 0; i < N; i++) {
      times[i] = Math.min(c.duration, i / fps);
      act.time = times[i];
      mixer.update(0);
      src.updateMatrixWorld(true);
      const W = {};
      for (const n of names) {
        W[n] = wq(srcB[n]).multiply(off[n]);
        const p = tb[n].parent,
          pw = W[p.name] || wq(p);
        pw.clone()
          .invert()
          .multiply(W[n])
          .toArray(vals[n], i * 4);
      }
    }
    mixer.stopAllAction();
    mixer.uncacheRoot(src);
    return new THREE.AnimationClip(
      c.name,
      c.duration,
      names.map((n) => new THREE.QuaternionKeyframeTrack(n + '.quaternion', times, vals[n])),
    );
  };
  // Retarget by world rotations. The source file rests arms-down while these models rest in a T-pose, so a copy of
  // the target is first bent until every bone points the way the source's does; that pair of poses defines the
  // per-bone offset, and each sampled source frame is mapped through it. Fingers stay at rest.
  const src = animSrc.scene,
    srcB = {},
    srcRest = {};
  src.traverse((o) => {
    if (o.isBone) {
      srcB[o.name] = o;
      srcRest[o.name] = o.quaternion.clone();
    }
  });
  const CHAIN = /^(Torso|Chest|Neck|Head|Abdomen|Spine)/,
    va = new THREE.Vector3(),
    vb = new THREE.Vector3();
  wq = (o) => o.getWorldQuaternion(new THREE.Quaternion());
  const boneDir = (b, kid) =>
    kid.getWorldPosition(va).sub(b.getWorldPosition(vb)).normalize().clone();
}
